


  
  

  var faMenu = {
    prefix: 'fak',
    iconName: 'menu',
    icon: [
      788,
      512,
      [],
      'e003',
      
      'M177 510V410l-51 82H110L59.2 410v98H23.8V341H55.3L118 445l63-104h32V508H177v2zm209-31v31H254V343H382v31H294v38h78v29H294v39h92v-1zM573 341V508H542L457 406V508H418V341h31l85 102V341h39zm59 151c-14-13-19-31-19-57V341h39v92c0 30 12 46 37 46c12 0 22-4 28-12s10-18 10-34V341h39v94c0 26-6 44-20 57c-13 14-31 20-57 20c-25 0-43-6-57-20zM.2 39.4C.2 17.6 17.8 0 39.5 0H748c22 0 40 17.6 40 39.4c0 21.7-18 39.4-40 39.4H39.5C17.8 78.8 .2 61.1 .2 39.4zM.2 197c0-22 17.6-39 39.3-39H748c22 0 40 17 40 39s-18 39-40 39H39.5C17.8 236 .2 219 .2 197z'
      
    ]
  };

  

  
  

  var faMenuEs = {
    prefix: 'fak',
    iconName: 'menu-es',
    icon: [
      788,
      512,
      [],
      'e004',
      
      'M176.8 510V410l-51 82h-16L59 410v98H23.6V341h31.5l62.7 104 63-104h32v167h-36v2zm209-31v31h-132V343h128v31h-88v38h78v29h-78v39h92v-1zm187-138v167h-31l-85-102v102h-39V341h31l85 102V341h39zM0 39.4C0 17.6 17.6 0 39.3 0h708.5c22 0 40 17.6 40 39.4s-18 39.4-40 39.4H39.3C17.6 78.8 0 61.1 0 39.4zM0 197c0-22 17.6-39 39.3-39h708.5c22 0 40 17 40 39s-18 39-40 39H39.3C17.6 236 0 219 0 197zM633.2 492.1c-13.4-13.3-20.1-32.3-20.1-56.9V341H652v92.7c0 30.1 12.5 45.2 37.5 45.2c12.2 0 21.5-3.6 27.9-10.9s9.6-18.7 9.6-34.2V341h38.4v94.1c0 24.7-6.7 43.6-20.1 56.9s-32.1 19.9-56.1 19.9s-42.7-6.6-56.1-19.9zm67.3-199.6H741l-43.7 34.8h-29.4l32.6-34.8z'
      
    ]
  };

  



export {

  faMenu,
  

  faMenuEs,
  

};
